/**
 * AI Service - Backend Proxy
 * Calls backend API which proxies to Groq
 * Solves CORS issues and secures API key
 */

import { AIGeneratedItem } from '../types/ai';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Generate shopping list using backend proxy
 */
export const generateShoppingList = async (
  prompt: string
): Promise<AIGeneratedItem[]> => {
  try {
    console.log('🚀 Calling backend AI proxy...');
    
    const response = await fetch(`${API_URL}/api/ai/generate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prompt }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    console.log(`✅ Received ${data.items?.length || 0} items from backend`);
    
    return data.items || [];
  } catch (error) {
    console.error('❌ Backend AI proxy failed:', error);
    throw error;
  }
};

/**
 * Check if backend AI is configured
 */
export async function isAIConfigured(): Promise<boolean> {
  try {
    const response = await fetch(`${API_URL}/health`);
    return response.ok;
  } catch {
    return false;
  }
}

/**
 * Get provider name for display
 */
export function getProviderName(): string {
  return 'Groq (Llama 3.1 70B)';
}
